import { useContext, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { toggleGlobalLoading } from '../../redux/actions/app';
import {
    deleteFormState, setFormInitialValues,
} from '../../redux/actions/forms';
import useRest from '../useRest';
import { layoutStateSelector } from '../../redux/selectors/layouts';
import { INestedLayoutParams } from '../../types/components';
import { LayoutContext } from '../../contexts/layout';

export const useFormData = ({ nestedParams }: INestedLayoutParams) => {
    const { objectId } = useParams();
    const { layoutId } = useContext(LayoutContext);
    const dispatch = useDispatch();
    const rest = useRest();
    const parentLayout = useSelector(layoutStateSelector(layoutId));

    const fetchFormData = async () => {
        if (typeof parentLayout.formDataLink === 'string') {
            let formDataUrl = parentLayout.formDataLink;
            const urlSearchParams = new URLSearchParams();

            if (typeof nestedParams?.rowId === 'string' || typeof nestedParams?.rowId === 'number') {
                urlSearchParams.append('id', nestedParams.rowId.toString());
            } else if (typeof objectId === 'string' && typeof nestedParams?.idOwner === 'undefined') {
                urlSearchParams.append('id', objectId);
            }

            if (typeof nestedParams?.idOwner === 'string' || typeof nestedParams?.idOwner === 'number') {
                urlSearchParams.append('idOwner', nestedParams.idOwner.toString());
            }

            if (Array.from(urlSearchParams).length > 0) {
                formDataUrl += `?${urlSearchParams.toString()}`;
            }

            const result = await rest.fetch({
                objectName: formDataUrl,
                method: 'post',
            });

            if (!result.isError && result.response?.data) {
                dispatch(setFormInitialValues(layoutId, result.response.data));
            }
        }
    };

    const getFormData = async () => {
        dispatch(toggleGlobalLoading({
            loading: true,
            title: 'Загрузка даных формы...',
        }));

        if (parentLayout.data instanceof Object) {
            dispatch(setFormInitialValues(layoutId, parentLayout.data));
        } else {
            await fetchFormData();
        }

        dispatch(toggleGlobalLoading({
            loading: false,
            title: 'Загрузка даных формы...',
        }));
    };

    useEffect(() => () => {
        dispatch(deleteFormState(layoutId));
    }, [layoutId]);

    useEffect(() => {
        getFormData();
    }, [parentLayout.data, parentLayout.formDataLink]);
};
